import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LayoutRoutingModule } from './layout-routing.module';
import { SharedModule } from '../shared/shared.module';
import { ContactModule } from '../contact/contact.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HeaderComponent } from './containers/header/header.component';
import { FooterComponent } from './containers/footer/footer.component';
import { LayoutComponent } from './components/layout/layout.component';
import { UpperHeaderComponent } from './components/upper-header/upper-header.component';
import { LowerHeaderComponent } from './components/lower-header/lower-header.component';
import { SingleHeaderNotificationComponent } from './components/single-header-notification/single-header-notification.component';
import { MobileHeaderComponent } from './components/mobile-header/mobile-header.component';

import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge'; 
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotificationsPanelComponent } from './components/notifications-panel/notifications-panel.component';

@NgModule({
	declarations: [
		HeaderComponent,
		FooterComponent,
		LayoutComponent,
		UpperHeaderComponent,
		LowerHeaderComponent,
		SingleHeaderNotificationComponent,
        MobileHeaderComponent,
        NotificationsPanelComponent,
	],
	imports: [
		CommonModule,
		LayoutRoutingModule,
		ReactiveFormsModule,
		SharedModule,
		ContactModule,
		BrowserAnimationsModule,
		ReactiveFormsModule,

		MatInputModule,
		MatIconModule,
		MatButtonModule,
		MatMenuModule,
		MatBadgeModule,
		MatDividerModule,
		MatDialogModule,
        MatSidenavModule,
		MatTooltipModule
	]
})
export class LayoutModule { }
